import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const LINKS = [
  { to: '/app',               label: 'Overview',       icon: '📊', end: true },
  { to: '/app/organizations', label: 'Organizations',  icon: '🏢' },
  { to: '/app/inquiries',     label: 'Inquiries',      icon: '📥' },
  { to: '/app/audit-logs',    label: 'Audit Logs',     icon: '🔐' },
];

export default function SuperAdminSidebar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <aside style={s.sidebar}>
      <div style={s.logo}>
        <img src="/maxxcom-logo.png" alt="MAXXCOM" style={{ height: 30, objectFit: 'contain', flexShrink: 0 }} />
        <div>
          <div style={s.logoText}>MAXXCOM</div>
          <div style={{ fontSize: 9, color: '#475569', letterSpacing: 0.3 }}>by AcceleratorX</div>
          <div style={s.logoSub}>Super Admin</div>
        </div>
      </div>

      <div style={s.roleTag}>
        Provider Panel
      </div>

      <nav style={s.nav}>
        {LINKS.map(l => (
          <NavLink
            key={l.to}
            to={l.to}
            end={l.end}
            style={({ isActive }) => ({ ...s.link, ...(isActive ? s.linkActive : {}) })}
          >
            <span style={{ fontSize: 16 }}>{l.icon}</span>
            {l.label}
          </NavLink>
        ))}
      </nav>

      <div style={s.footer}>
        <p style={s.email}>{user?.email}</p>
        <button style={s.logoutBtn} onClick={logout}>Logout</button>
      </div>
    </aside>
  );
}

const s = {
  sidebar: { width: 220, minHeight: '100vh', background: '#0d1117', borderRight: '1px solid #21262d', display: 'flex', flexDirection: 'column', padding: '20px 12px' },
  logo: { display: 'flex', alignItems: 'center', gap: 10, padding: '0 8px 20px', borderBottom: '1px solid #21262d' },
  logoText: { fontWeight: 700, fontSize: 15, color: '#f1f5f9' },
  logoSub: { fontSize: 11, color: '#6366f1', fontWeight: 600, letterSpacing: 1 },
  roleTag: { margin: '12px 0', padding: '6px 10px', background: '#1a1f2e', borderRadius: 6, fontSize: 11, color: '#94a3b8', fontWeight: 600, border: '1px solid #6366f133', textAlign: 'center', letterSpacing: 0.5 },
  nav: { display: 'flex', flexDirection: 'column', gap: 2, flex: 1, marginTop: 8 },
  link: { display: 'flex', alignItems: 'center', gap: 10, padding: '10px 12px', borderRadius: 8, fontSize: 14, color: '#6e7681', textDecoration: 'none' },
  linkActive: { background: '#1e293b', color: '#f1f5f9', fontWeight: 600 },
  footer: { borderTop: '1px solid #21262d', paddingTop: 16 },
  email: { fontSize: 11, color: '#6e7681', padding: '0 8px', marginBottom: 8, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
  gatewayBtn: { width: '100%', padding: '8px', background: 'transparent', border: '1px solid #f9731640', borderRadius: 8, color: '#f97316', cursor: 'pointer', fontSize: 13, marginBottom: 10 },
  logoutBtn: { width: '100%', padding: '8px', background: 'transparent', border: '1px solid #21262d', borderRadius: 8, color: '#6e7681', cursor: 'pointer', fontSize: 13 },
};
